export default "__VITE_ASSET__X1RF8SDE__"